import React from "react";
import { Layout, theme } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const { Footer: AntFooter } = Layout;

const footerStyle = {
  textAlign: "center",
};

export default function Footer() {
  const { t } = useTranslation();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <AntFooter style={{ ...footerStyle, backgroundColor: colorBgContainer }}>
      {t("footer.developedAt")} {" | "}
      <Link to="/legal-notice">{t("footer.legalNotice")}</Link>
      {" | "}
      <Link to="/cookie-settings">{t("footer.cookieSettings")}</Link>
    </AntFooter>
  );
}
